import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { CartContext } from "../context/CartContext";
import ItemCount from "./ItemCount";
import Carousel from "./Carousel";
import Seo from "./Head";

export const ItemDetail = ({ itemDetail, onHandleCartModal }) => {
  const { addToCart, cantidadSeleccionada } = useContext(CartContext);

  let imagenesArray = [];
  try {
    imagenesArray =
      typeof itemDetail.imagenes === "string"
        ? JSON.parse(itemDetail.imagenes || "[]")
        : itemDetail.imagenes;
  } catch (e) {
    imagenesArray = [];
  }

  const onAdd = (cantidad) => {
    onHandleCartModal();
    addToCart(itemDetail);
  };

  const cantidadEnCart = cantidadSeleccionada(itemDetail.id);

  const settings = {
    dots: false,
    arrows: true,
    infinite: imagenesArray.length > 1,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: false,
    responsive: [
      {
        breakpoint: 678,
        settings: {
          slidesToShow: 1,
          arrows: false,
          autoplay: true,
          autoplaySpeed: 2000,
        },
      },
    ],
  };

  return (
    <>
      <Seo
        title={itemDetail.titulo}
        description={itemDetail.precio}
        image={imagenesArray.length > 0 ? imagenesArray[0].url : ""}
        pathSlug={window.location.href}
      />

      <div className="row">
        {/* COLUMNA 1: FOTOS (Aparece primero en mobile) */}
        <div
          className="card col-12 col-md-6 ps-md-5 pe-md-5 mt-md-3"
          key={itemDetail.id}
        >
          {imagenesArray.length > 0 ? (
            <Carousel settings={settings}>
              {imagenesArray.map((img, index) => (
                <div key={`${itemDetail.id}-${index}`}>
                  <img
                    src={img.url}
                    alt={itemDetail.titulo}
                    className="img-fluid"
                  />
                </div>
              ))}
            </Carousel>
          ) : (
            <div className="text-center p-5">Cargando imágenes...</div>
          )}
        </div>

        {/* COLUMNA 2: DATOS (Aparece debajo de la foto en mobile) */}
        <div className="card pe-3 ps-3 datos mt-3 col-12 col-md-6">
          {/* BOTÓN VOLVER: Ahora está aquí dentro */}
          <div className="mb-4 mt-0 mt-md-2">
            <Link
              to={`/tienda/${itemDetail.categoria_slug}`}
              className="volver-link"
            >
              {"<"} VOLVER A {itemDetail.categoria?.toUpperCase()}
            </Link>
          </div>

          <div>
            <h1>{itemDetail.titulo}</h1>
            <h4 className="gris">
              {itemDetail.categoria} / stock: {itemDetail.stock}
            </h4>

            <p className="text-start negrita">
              <span className="negrita me-2">
                ${Number(itemDetail.precio).toLocaleString("es-AR")}
              </span>
            </p>
          </div>

          <div
            className="mt-3 htmlEn"
            dangerouslySetInnerHTML={{ __html: itemDetail.descripcion }}
          />

          <div className="mt-3">
            <h4>
              <i className="bi bi-bank me-2"></i>Transferencia / Mercado Pago
            </h4>
            <h4>
              <i className="bi bi-truck me-2"></i>Envíos a todo el país!
            </h4>
            <h4>
              <i className="bi bi-person-check me-2"></i>Asesoramiento
              personalizado
            </h4>
          </div>

          <h4
            className={
              itemDetail.stock === 0
                ? "d-block stockCero text-center"
                : "d-none"
            }
          >
            Producto sin stock. Consultar próximo ingreso
          </h4>

          <h4 className="text-center text-md-start mt-3">
            <ItemCount
              stock={itemDetail.stock}
              initial={cantidadEnCart === undefined ? 1 : cantidadEnCart}
              onAdd={onAdd}
            />
          </h4>
        </div>
      </div>
    </>
  );
};
